import { Divider } from '@mui/material';

function BakeasyDivider() {
  return <Divider sx={{ mx: 0, my: 2 }} />;
}

export default BakeasyDivider;
